import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {PageEvent} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";

export interface ContactDealTable {
  deal: string,
  dealUrl: string,
  deal_type: string,
  project_status: string,
  role: string,
  closing_date: string,
  risk_rating: string,
  location: string,
  county: string,
  organization: string,
  organizationUrl: string,
  tax_perc: string,
  lt_equity: string,
  lt_equity_value: number[],
  ppc: string;
  ppcValue: number[];
  lt_yield: number;
  construction: string;
  resident: string;
  total_units: number;
  total_lihtc: number;
  hard_debt: number;
  outlets: string;
}
@Component({
  selector: 'contact-deals-table',
  templateUrl: './contact-deals-table.component.html',
  styleUrls: ['./contact-deals-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ContactDealsTableComponent implements OnInit, AfterViewInit, OnChanges{
  @Input() deals: ContactDealTable[];
  @Input() totals: any;
  @Input() pageInfo: any;
  @Input() isSponsorAssociatedTable: boolean = false;
  @Output() paginate: EventEmitter<any> = new EventEmitter()
  public rollup:any = {
    rankings: [
      {key: "A", value: 0},
      {key: "B", value: 0},
      {key: "C", value: 0},
      {key: "D", value: 0},
      {key: "F", value: 0}
    ],
    closed: {
      count: 0,
      units: 0,
      lihtc_units: 0,
      lt_equity: 0,
      avg_hard_debt: 0,
      avg_lt_yield: 0,
      avg_ppc: 0
    },
    closing: {
      count: 0,
      units: 0,
      lihtc_units: 0,
      lt_equity: 0,
      avg_hard_debt: 0,
      avg_lt_yield: 0,
      avg_ppc: 0
    },
  }


  public dealsColumns:string[]  = ['deal', 'type', 'project_status', 'role', 'closing_date', 'risk_rating', 'location',
    'county', '4%/9%', 'lt_equity', 'ppc', 'lt_yield', 'construction', 'resident', 'total_units', 'total_lihtc', 'hard_debt', 'outlets']
  public dataSource: MatTableDataSource<ContactDealTable>;
  @ViewChild(MatSort) matSort: MatSort

  ngOnInit(){
    if(this.isSponsorAssociatedTable){
      this.dealsColumns.splice(5,0, 'organization')
    }
    this.dataSource = new MatTableDataSource(this.deals)
    this._calculateRollup(this.totals)
  }

  ngOnChanges(changes: SimpleChanges){
    if(changes['deals'] && !changes['deals'].firstChange){
      this.dataSource = new MatTableDataSource(changes['deals'].currentValue)
      this.dataSource.sort = this.matSort
      this.dataSource.sortingDataAccessor = this._sortingDataAccessor;
    }
  }

  ngAfterViewInit(){
    this.dataSource.sort = this.matSort

    this.dataSource.sortingDataAccessor = this._sortingDataAccessor
  }

  private _calculateRollup(totals: any){
    this.rollup.closed = totals.closed;
    this.rollup.closing = totals.closing;
    for(let risk of Object.keys(totals.risk_ratings)){
      if(risk.includes('risk_rating')){
        let key = risk.split('risk_rating_')[1].toUpperCase()
        let value = totals.risk_ratings[risk]
        this.rollup.rankings.forEach((rank:any) => {
          if(rank.key == key){
            rank.value = value;
          }
        })
      }
    }
  }

  public getPage(event: PageEvent){
    this.paginate.emit(event)
  }

  private _sortingDataAccessor = (item: ContactDealTable, property: string): string | number => {
    if (property === 'closing_date') {
      const date = new Date(item.closing_date);
      return isNaN(date.getTime()) ? 0 : date.getTime();
    }
    return (item as any)[property];
  };

}
